module.exports = __webpack_public_path__ + "img/logo_estela.bc334557.png";